import type { RouteRecordRaw } from 'vue-router';

export const loginRoute: RouteRecordRaw = {
  path: '/login',
  name: 'Login',
  component: () => import('./pages/LoginPage.vue'),
  meta: {
    layout: 'empty',
    public: true,
  },
};

export const magicLinkRoute: RouteRecordRaw = {
  path: '/magic-link',
  name: 'MagicLink',
  component: () => import('./pages/MagicLinkPage.vue'),
  meta: {
    layout: 'empty',
    public: true,
  },
};
